<template>
  <div class="dados-infracao">
    <Card title="Dados Agente">
      <v-list-item v-if="user !== null">
        <v-list-item-content>
          <v-list-item-title>
            <span class="font-weight-black">Matrícula:</span>
            {{ user.agente.matricula }}
          </v-list-item-title>

          <v-list-item-title>
            <span class="font-weight-black">Nome:</span>
            {{ user.agente.nome }}
          </v-list-item-title>

          <v-list-item-title>
            <span class="font-weight-black">Justificativa:</span>
            {{ justificativa ? justificativa : "" }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card";
export default {
  name: "DadosAgente",
  components: { Card },
  props: {
    user: {
      type: [Object, String],
      default: null,
    },

    justificativa: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: [
        { text: "Orgão Autuador", value: "AMC" },
        { text: "Descrição da Infração", value: "infracao.descricao" },
      ],
    };
  },
};
</script>
